export const Routes = {
    // pages
    Presentation: { path: "/dashboard/overview" },
    DashboardOverview: { path: "/dashboardoverview" },
    Transactions: { path: "/transactions" },
    Settings: { path: "/settings" },
    Signin: { path: "/" },
    EditOrganisation: { path: '/company/edit-organisation' },
    AddEntities: { path: '/company/add-entities' },
    EditEntities: { path: '/company/edit-entities/:id' },
    AddDepartment: { path: '/department/add-department' },
    EditDepartment: { path: '/department/edit-department/:id' },
    AddWorkPlaces: { path: '/company/add-workplaces' },
    EditWorkPlaces: { path: '/company/edit-workplaces/:id' },
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    Signup: { path: "/examples/sign-up" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" },
    Welcome: { path: "/welcome" },
    Company: { path: "/company" },
    Employee: { path: "/employee" },
    Department: { path: "/department" },
    AddEmployee: { path: "/employee/add-employee" },
    EditEmployee: { path: "/employee/edit-employee/:id" },
    PermissionGroup: { path: "/permission-group" },
    AddPermissionGroup: { path: "/permission-group/add-permission-group" },
    Brand: { path: "/brand" },
    AddBrand: { path: "/brand/add-brand" },
    EditBrand: { path: "/brand/edit-brand/:id" },
    Category: { path: "/category" },
    AddCategory: { path: "/category/add-category" },
    EditCategory: { path: "/category/edit-category/:id" },
    Spusku: { path: "/spu-sku" },
    AddSpu: { path: "/spu-sku/add-spu" },
    EditSpu: { path: "/spu-sku/edit-spu/:id" },
    SkuPresets: { path: "/sku-presets" },
    BulkImport: { path: "/sku-presets/bulk-import" },
    Branch: { path: "/branches" },
    AddBranch: { path: "/branches/add-branch" },
    EditBranch: { path: "/branches/edit-branch/:id" },
    StockList: { path: "/stock-list" },
    StockListTest: { path: "/stock-list-test" },
    ListingPricing: { path: "/listing-pricing" },
    ListingPricingTest: { path: "/listing-pricing-test" },
    PlatformListingTest: { path: "/platform-listing-test" },
    PlatformListingFetchTest: { path: "/platform-listing-fetch-test" },
    AddEditPlatformListing: { path: "/listing-pricing-test/add-listing" },
    AddListing: { path: "/listing-pricing/add-listing" },
    EditListing: { path: "/listing-pricing/edit-listing" },
    BulkPricing: { path: "/listing-pricing/bulk-pricing" },
    PlatformOrder: { path: "/platform-order" },
    LinkStockInstance: { path: "/platform-order/link-stock-instance" },
    PlatformOrderLinked: { path: "/platform-order-linked" },
    PlatformOrderShopee: { path: "/platform-order-shopee" },
    PlatformOrderLazada: { path: "/platform-order-lazada" },
    PlatformOrderTiktok: { path: "/platform-order-tiktok" },
    PlatformOrderShopeeTest: { path: "/platform-order-shopee-test" },
    PlatformOrderLazadaTest: { path: "/platform-order-lazada-test" },
    PlatformOrderTiktokTest: { path: "/platform-order-tiktok-test" },
    PlatformManageOrder: { path: "/platform-manage-order" },
    PlatformManageOrderTest: { path: "/platform-manage-order-test" },
    AbbreviationsDictionary: { path: "/skuscheme/AbbreviationsDictionary" },
    SkuScheme: { path: "/skusheme/SkuScheme" },
    PlatformPricing: { path: "/platform-pricing" },
    PlatformBulkPricing: { path: "/platform-pricing/bulk-pricing" },
    PlatformPricingImport: { path: "/platform-pricing/import" },
    PlatformListingImport: { path: "/listing-pricing/import" },
    TradeInListing: { path: "/trade-in-listing" },
    TradeInListingTest: { path: "/trade-in-listing-test" },
    TradeInListingItems: { path: "/trade-in-listing/items" },
    AddTradeInListing: { path: "/trade-in-listing/add-listing" },
    EditTradeInListing: { path: "/trade-in-listing/edit-listing" },
    AddTradeInListingStep2: { path: "/trade-in-listing/add-listing/items" },
    AddTradeInListingStep3: { path: "/trade-in-listing/add-listing/pricing" },
    EditTradeInListingStep2: { path: "/trade-in-listing/edit-listing/items" },
    EditTradeInListingStep3: { path: "/trade-in-listing/edit-listing/pricing" },
    TradeInPricing: { path: "/trade-in-pricing" },
    TradeInPricingPromotional: { path: "/trade-in-pricing/promotional-campaign" },
    TradeInPricingPromotionalTest: { path: "/trade-in-pricing/promotional-campaign-test" },
    TradeInPricingEditCampaign: { path: "/trade-in-pricing/promotional-campaign/edit" },
    TradeInPricingHistory: { path: "/trade-in-pricing/pricing-history" },
    TradeInPricingHistoryTest: { path: "/trade-in-pricing/pricing-history-test" },
    PricingTemplate: { path: "/pricing-template" },
    AddPricingTemplate: { path: "/pricing-template/add" },
    AddPricingTemplateTest: { path: "/pricing-template/add-test" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" },
    SpuSkuPage: { path: "/inventory/spus/:spu_id/skus"},
    StockInstancePage: { path: "/inventory/stock/:stock_id/stockInstance"}
};